import { useTranslation } from 'next-i18next';

import { Box, Flex, IconButton, Link, Text } from '@chakra-ui/react';

import { IconProps } from '@nocowanie/icons/common';
import { IconsNocowanie } from '@nocowanie/icons/nocowanie';

import { SocialMediaProps } from './social-media.props';
import { defaultSocialMediaTranslation } from './social-media.translation.model';

export const SocialMedia = ({
    translationData = defaultSocialMediaTranslation,
    ...props
}: SocialMediaProps) => {
    const { t } = useTranslation('socialMedia');

    const iconConfig: IconProps = {
        fontSize: '2xl',
    };

    const SocialMediaData = [
        {
            url: t('facebook.url'),
            label: t('facebook.label'),
            icon: <IconsNocowanie.Facebook {...iconConfig} />,
        },
        {
            url: t('youtube.url'),
            label: t('youtube.label'),
            icon: <IconsNocowanie.Youtube {...iconConfig} />,
        },
        {
            url: t('instagram.url'),
            label: t('instagram.label'),
            icon: <IconsNocowanie.Instagram {...iconConfig} />,
        },
    ];

    return (
        <Box {...props}>
            <Text
                fontSize={{
                    md: 'lg',
                }}
            >
                {translationData.followUs}
            </Text>
            <Flex
                mt={{
                    base: 3,
                    md: 4,
                }}
                gap={6}
            >
                {SocialMediaData.map((item, index) => (
                    <IconButton
                        asChild
                        key={index}
                        p={3}
                        color={'white'}
                        border={'1px solid #fff'}
                        borderRadius={'full'}
                        _hover={{
                            bg: 'white',
                            color: 'secondary.600',
                        }}
                        variant={'outline'}
                        colorPalette={'white'}
                    >
                        <Link
                            href={item.url}
                            target="_blank"
                            rel="nofollow noopener"
                            aria-label={item.label}
                        >
                            {item.icon}
                        </Link>
                    </IconButton>
                ))}
            </Flex>
        </Box>
    );
};
